<template>
  <el-container class="view-content">
    <el-header class="header-content">
      <el-form :model="searchItem" label-width="auto" inline size="small">
        <el-form-item label="上传时间">
          <date-picker v-model="searchItem.create_at" type="before" width="170px"></date-picker>
        </el-form-item>
        <el-form-item label="设备型号">
          <el-input v-model.trim="searchItem.model" clearable></el-input>
        </el-form-item>
        <el-form-item label="插件版本">
          <el-input v-model.trim="searchItem.sversion" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
        <el-button-group>
          <el-button type="primary" @click="add" size="small">上传插件</el-button>
        </el-button-group>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <vue-table :table-data="tableData">
        <template slot="actionBar">
          <el-table-column align="center" label="操作栏" :resizable="false" width="120">
            <template slot-scope="scope">
              <!--升级-->
              <el-button type="text" @click="upgrade(scope.row)" :disabled="+scope.row.status === 0">下发</el-button>
              <!--修改-->
              <el-button type="text" @click="revise(scope.row)">修改</el-button>
              <!--禁用-->
              <el-button class="danger" type="text" @click="remove(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </template>
      </vue-table>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging"></vue-pagination>
    </el-footer>
    <plugin-operate v-if="pluginOperate.visible" :dialog-data="pluginOperate" @table-reload="getTableList" />
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import PluginOperate from "./dialog/PluginOperate"
  import DatePicker from '@view/components/date/DatePicker'
  import {pluginStatus,pluginType} from "@utils/formatList"
  import Statistics from "@view/components/Statistics"
  export default {
    name: "pluginList",
    mixins: [PagingData],
    components: {PluginOperate, DatePicker, Statistics},
    data() {
      return {
        // 查询项
        searchItem: {
          model: "",
          sversion: "",
          create_at: ""
        },
        commitItem: null,
        // 统计
        countList: [
          {name: "插件总数", count: 0},
        ],
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "上传时间", property: "create_at",width: 160},
            {label: "上传者", property: "user.name", width: 100},
            {label: "插件类型", property: "type", width: 90, format: pluginType},
            {label: "硬件平台", property: "platform", width: 100},
            {label: "插件版本", property: "sversion", width: 100},
            {label: "内核版本", property: "kversion", width: 100},
            {label: "MD5", property: "file_md5", minWidth: 250},
            {label: "备注", property: "remark"},
            {label: "下载次数", property: "counter", width: 90},
            {label: "状态", property: "status", width: 60, format: pluginStatus},
          ]
        },
        pluginOperate: {
          title: '',
          visible: false,
          row: null,
        },
      }
    },
    methods: {
      add() {
        this.pluginOperate.visible = true;
        this.pluginOperate.title = "上传插件";
        this.pluginOperate.row = null;
      },
      revise(row) {
        this.pluginOperate.visible = true;
        this.pluginOperate.title = "修改插件";
        this.pluginOperate.row = row;
      },
      remove(row) {
        this.openConfirm("删除该插件", async ()=> {
          let nv = {};
          nv.optionId = row.id;
          let res = await this.$Http.deletePlugin(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.$refs["paging"].removeFinish(1);
            this.getTableList();
          }
        });
      },
      upgrade(row) {
        this.openConfirm("升级该插件", async ()=> {
          let nv = {plugin_id: row.id};
          let res = await this.$Http.upgradePlugin(nv);
          if (res) {
            this.msgSuccess("下发成功");
            this.getTableList();
          }
        });
      },
      // 查询
      search() {
        this.commitItem = {...this.searchItem};
        this.pagingData.currentPage = 1;
        this.getTableList();
      },
      // 获取用户列表
      async getTableList() {
        let nv = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize
        };
        // 添加筛选项
        this.copyObjValue(nv, this.commitItem);
        let res = await this.$Http.getPluginList(nv);
        if (res?.data) {
          let total = +res.data.total || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.tableData.tableList = this.getArray(res.data.list);
        }
      }
    },
    created() {
      this.getTableList();
    }
  }
</script>

<style scoped>

</style>
